import UsesrDataTable from "./sub_components/users_data_table"

export default function UsersPage() {
  return (
    <>
      <UsesrDataTable />
    </>
  )
}
